/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import OnboardingStylesWrapper, {
  BookDemoWrapper,
  useOnboardingStyles,
} from '../src/components/onboarding/OnboardingDesignWrapper';
import Cookies from 'js-cookie';
import { withPageAuthRequired } from '@auth0/nextjs-auth0';
import {
  AppBar,
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tab,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useRouter } from 'next/router';
import { debounce, get } from 'lodash';
import MetaTagGenerator from '../src/components/shared/MetaTagGenerator';
import CustomTextField from '../src/components/onboarding/CustomTextField';
import HubSpotService, { FormConfigMap } from '../src/utility/services/hubSpot';
import { isCorporateAndValidEmail } from '../src/utility/validation/email';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';
import { useUser } from '@auth0/nextjs-auth0/client';
import { signOut } from '../src/utility/services/authActions';
import Link from 'next/link';
import { CONTENT_AI_USER_TYPE, SUBSCRIPTION_STATUS } from '../src/constants/common';
import { segmentEventApi, setUserAttribute, trackAnalyticsEvent } from '../src/constants/analyticsMeta';
import { useQuestionsStyles } from '../src/components/content-ai-tools/components/DescribeQuestion';
import CustomerDropDownWithLock from '../src/components/content-ai-tools/components/CustomerDropDownWithLock';
import CustomSelect from '../src/components/onboarding/CustomSelect';
import { useRollbar } from '@rollbar/react';
import { formatUnixDate, isProductionEnv, USER_CLASSIFICATION } from '../src/utility/common';
import ToolsOnboardingWrapper from '../src/components/onboarding/ToolsOnboardingWrapper';
import PricingSection from '../src/components/onboarding/PricingSection';
import { QuattrLogoSpinner } from '../src/components/content-ai-tools/components/QuattrLogoSpinner';
import { setCookie } from '../src/components/content-ai-tools/components/tools-common';
import { useSession } from '../src/utility/services/customHooks';
import auth0 from 'auth0-js';
import { v4 as uuidv4 } from 'uuid';
import { QLoaderWithHeadingDescription } from '../src/components/content-ai-tools/components/QLoaderWithHeadingDescription';
import { auth0Axios } from '../src/utility/services/api/auth0Axios';

export const useSignUpStyles = makeStyles((theme) => ({
  signUpWithGoogle: {
    borderRadius: '3.528px',
    background: '#2D3748',
    // width: '100%',
    padding: '0px 16px',
    color: '#FFF',
    height: '55px',
    textTransform: 'inherit',
    fontFamily: 'Roboto',
    fontSize: '19px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    '&:hover': {
      backgroundColor: '#2D3748',
    },
    '&:disabled': {
      backgroundColor: 'lightgray',
      color: 'gray',
    },
  },
  signUpWithGoogleForTools: {
    width: '100%',
  },
  signUpSubHeading: {
    fontSize: '12px',
    fontWeight: 700,
  },
  changeEmailAddress: {
    fontSize: '12',
    color: '#51D497',
    fontFamily: 'Poppins',
    fontWeight: 400,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  alreadyExistHeading: {
    fontSize: '12px',
    fontWeight: 700,
    maxWidth: '282px',
    margin: 'auto',
    marginTop: '20px',
  },
  svgStyle: {
    margin: '0px 8px',
  },
  gscWarning: {
    color: '#212121',
    textAlign: 'left',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  gscText: {
    color: '#212121',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
  },
  // v2
  signUpCard: {
    maxWidth: '382px',
    borderRadius: '10px',
    border: '2px solid #51D497',
    boxShadow: 'none',
    padding: '40px 28px',
    textAlign: 'center',
    margin: 'auto',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: '40px 15px',
    },
    '&::before': {
      content: '"NO CREDIT CARD NEEDED"',
      display: 'block',
      position: 'absolute',
      top: '-16px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: 'white',
      color: '#DB1A1A',
      border: '2px solid #DB1A1A',
      padding: '7px 14px',
      borderRadius: '20px', // Adjusted to only bottom corners
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '10px',
      textAlign: 'center',
      width: 'auto',
      maxWidth: 'calc(100% - 40px)', // Ensures padding from edges
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  },
  hideCreditCardMessage: {
    '&::before': {
      display: 'none',
    },
  },
  emailInput: {
    marginBottom: theme.spacing(1),
  },
  signUpButton: {
    marginTop: theme.spacing(2),
    display: 'flex',
    width: '100%',
    height: '39px',
    padding: '10.456px 16.265px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6.971px',
    // background: '#757575',
    textTransform: 'capitalize',

    // color: '#DEDEDE',
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20.912px',

    background: '#51D497',
    color: '#1D3557',
    '&.MuiButton-containedPrimary:hover': {
      backgroundColor: '#51D497',
    },
  },
  dynamicWidthBtn: {
    maxWidth: '300px',
    margin: '17px auto',
  },
  outlined: {
    borderRadius: '10px',
    border: '2px solid #1D3557',
    background: '#F6F7F9',
    margin: '17px auto',
    maxWidth: '218px',
  },
  largeCTA: {
    height: '50px',
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: '"Source Sans Pro"',
    fontSize: '18.9px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '108%',
  },
  loginText: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    marginTop: '9px',
  },
  loginLink: {
    color: '#51D497',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    textDecoration: 'none',
    marginTop: theme.spacing(2),
  },
  dividerContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '21px 0px',
    justifyContent: 'center',
  },
  divider: {
    flexGrow: 1,
    background: '#757575',
  },
  dividerText: {
    margin: '0px 9px',
    color: '#757575',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  secondaryText: {
    color: '#757575',
    fontFamily: 'Poppins',
    fontSize: '10px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    textAlign: 'left',
  },
  concentText: {
    color: '#757575',
    textAlign: 'center',
    fontFamily: '"Source Sans Pro"',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    maxWidth: '424px',
    margin: '10px 7%',
  },
  termsCheckBox: {
    marginTop: '16px',
  },
  grayedOutContainer: {
    background: '#F6F7F9',
    padding: '31px 60px 30px 60px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const isValidDomain = (domain) => {
  const re =
    /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
  return re.test(domain);
};

const isDomainMatch = (email: string, enteredDomain: string): boolean => {
  // Extract the domain from the email
  const emailDomain = email.split('@')[1].toLowerCase();

  // Remove protocol (http:// or https://) and any paths from entered domain
  const normalizedEnteredDomain = enteredDomain
    .replace(/^(?:https?:\/\/)?(?:www\.)?/i, '')
    .split('/')[0]
    .toLowerCase();

  // Check if the domains match
  return emailDomain === normalizedEnteredDomain;
};

const StepEnum = {
  SIGN_UP: 'SIGN_UP',
  DETAILS: 'DETAILS',
  CONFIRMATION: 'CONFIRMATION',
  VERIFY_OTP: 'VERIFY_OTP',
  CREATE_PASSWORD: 'CREATE_PASSWORD',
  ACCOUNT_ALREADY_EXIST: 'ACCOUNT_ALREADY_EXIST',
};

export const OnboardingForm = ({
  parentClasses,
  headingText,
  postRedirects,
  setGoBack,
  setFullPageContentAiLoader,
}) => {
  const classes = useSignUpStyles();
  const questionStyles = useQuestionsStyles();
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [code, setCode] = useState('');
  const [usedPersonalEmail, setUsedPersonalEmail] = useState(false);
  const [usedCorpEmail, setUsedCorpEmail] = useState(false);
  const [apiError, setApiError] = useState('');
  const [domain, setDomain] = useState('https://');
  const { user } = useUser();

  const [loading, setLoading] = useState(false);
  const step_from_query = router.query.step || StepEnum.SIGN_UP;
  const reason_from_query = router.query.reason || '';
  const [step, setStep] = useState(step_from_query);
  const [isRequestApproved, setIsRequestApproved] = useState(false);
  const [checkboxError, setCheckboxError] = useState('');
  const [checked, setChecked] = useState(false);
  const [signUpWithGoogleLoader, setSignUpWithGoogleLoader] = useState(false);
  const [error, setError] = useState<{
    email?: boolean;
    firstName?: boolean;
    lastName?: boolean;
    domain?: boolean;
    code?: boolean;
    password?: boolean;
    reEnteredPassword?: boolean;
  }>({});
  const [errorMessage, setErrorMessage] = useState<{
    email?: string;
    firstName?: string;
    lastName?: string;
    domain?: string;
    code?: string;
    password?: string;
    reEnteredPassword?: string;
  }>({});
  function decodeHtmlEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }

  const handleCheckboxChange = (event) => {
    setCheckboxError('');
    setChecked(event.target.checked);
  };

  useEffect(() => {
    if (reason_from_query) {
      const decodedString = decodeHtmlEntities(reason_from_query);
      const decodedUserInfo = JSON.parse(decodedString);
      if (decodedUserInfo && decodedUserInfo?.user?.email) {
        setEmail(decodedUserInfo.user.email);
        setFirstName(decodedUserInfo.user.given_name);
        setLastName(decodedUserInfo.user.family_name);
        setUsedPersonalEmail(true);

        if (window.analytics) {
          window.analytics.identify(decodedUserInfo.user.email, {
            email: decodedUserInfo.user.email,
            name: `${decodedUserInfo.user.given_name} ${decodedUserInfo.user.family_name}`,
            schema: '',
            instance_type: 'Content AI',
            user_type: CONTENT_AI_USER_TYPE,
            company_name: '',
          });
          window.analytics.track('Signup with Google initiated', {
            emailType: 'Personal',
            email: decodedUserInfo.user.email,
            name: `${decodedUserInfo.user.given_name} ${decodedUserInfo.user.family_name}`,
          });
        } else {
          const payload = {
            email: decodedUserInfo.user.email,
            name: `${decodedUserInfo.user.given_name} ${decodedUserInfo.user.family_name}`,
            schema: '',
            instance_type: 'Content AI',
            emailType: 'Personal',
            user_type: CONTENT_AI_USER_TYPE,
            company_name: '',
          };
          segmentEventApi(null, payload, 'identify');
          segmentEventApi('Signup with Google initiated', payload, 'track');
        }
      }
    }
  }, [reason_from_query]);

  useEffect(() => {
    if (user && user.email && user.name && user.connection == 'google-oauth2') {
      // tracking
      if (window.analytics) {
        window.analytics.identify(user.email, {
          email: user.email,
          name: user.name,
          schema: '',
          instance_type: 'Content AI',
          user_type: CONTENT_AI_USER_TYPE,
          company_name: '',
        });
        window.analytics.track('Signup with Google initiated', {
          emailType: 'Corporate',
          email: user.email,
          name: user.name,
        });
      } else {
        const payload = {
          emailType: 'Corporate',
          email: user.email,
          name: user.name,
          schema: '',
          instance_type: 'Content AI',
          user_type: CONTENT_AI_USER_TYPE,
          company_name: '',
        };
        segmentEventApi(null, payload, 'identify');
        segmentEventApi('Signup with Google initiated', payload, 'track');
      }
      // setting states
      if (user?.email && user?.given_name && user?.family_name) {
        setEmail(user?.email);
        if (typeof user?.given_name == 'string') {
          setFirstName(user?.given_name);
        }
        if (typeof user?.family_name == 'string') {
          setLastName(user?.family_name);
        }
        setUsedCorpEmail(true);
      }
    }
  }, [user]);
  useEffect(() => {
    if (step !== StepEnum.SIGN_UP) {
      setGoBack(false);
    }
  }, [step]);

  useEffect(() => {
    console.log('ASDF', { step, user, email, reason_from_query });
    if (step === StepEnum.DETAILS && (user || email || reason_from_query)) {
      const isGoogleCorpUser = user && user.email && user.name && user.connection == 'google-oauth2';
      trackAnalyticsEvent({
        eventName: 'Viewed',
        payload: {
          label:
            email && !reason_from_query && !isGoogleCorpUser
              ? 'Enter domain - work email'
              : 'Enter domain - google signup',
        },
      });
    }
  }, [step, user]);

  useEffect(() => {
    const handleStorageEvent = () => {
      if (localStorage.getItem('signup-request-submitted') === 'true') {
        setStep(StepEnum.CONFIRMATION);
      }
    };

    // Listen for storage events from other tabs
    window.addEventListener('storage', handleStorageEvent);

    // Cleanup function for the listener
    return () => window.removeEventListener('storage', handleStorageEvent);
  }, []);

  useEffect(() => {
    const isRequestSubmitted =
      sessionStorage.getItem('signup-request-submitted') || localStorage.getItem('signup-request-submitted');
    const decodedString = reason_from_query ? decodeHtmlEntities(reason_from_query) : '{}';
    const decodedUserInfo = JSON.parse(decodedString);
    if (isRequestSubmitted && decodedUserInfo && decodedUserInfo?.user?.email) {
      setLoading(true);
      axios
        .post(
          '/api/join-content-ai/user-check',
          { ...decodedUserInfo },
          {
            headers: { 'Content-Type': 'application/json' },
          }
        )
        .then((res) => {
          const response = res.data;
          if (response && response.success) {
            setIsRequestApproved(true);
          } else {
            // logout user if request is already submitted
            // this is specifically when user tries to do signup with google after submitting request and before his request is approved
            window.location.href = `https://auth.quattr.com/v2/logout?client_id=${
              process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID
            }&returnTo=${encodeURIComponent(
              `${process.env.NEXT_PUBLIC_HOST_URL}/get-started?tab=start-free-trial&&step=${StepEnum.CONFIRMATION}`
            )}`;
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (isRequestSubmitted) {
      setStep(StepEnum.CONFIRMATION);
    }
  }, []);

  const handleSignUpNoWClick = async (step = StepEnum.SIGN_UP) => {
    const newError = { ...error };
    const newErrorMessage = { ...errorMessage };
    let allValid = true; // Flag to track if all validations pass

    if (step === StepEnum.SIGN_UP) {
      setLoading(true);
      if (!email) {
        newErrorMessage.email = '* Required';
        newError.email = true;
        allValid = false;
      } else if (!email?.includes('@')) {
        newErrorMessage.email = 'Invalid Work Email';
        newError.email = true;
        allValid = false;
      } else {
        newErrorMessage.email = '';
        newError.email = false;
        if (allValid) {
          if (window.analytics) {
            window.analytics.identify(email, {
              email: email,
              name: '',
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              company_name: '',
            });
            window.analytics.track('ButtonClick - Verify Email', {
              email: email,
              name: '',
            });
          } else {
            const payload = {
              email: email,
              name: '',
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              company_name: '',
            };
            segmentEventApi(null, payload, 'identify');
            segmentEventApi('ButtonClick - Verify Email', payload, 'track');
          }
          await axios.post(
            '/api/join-content-ai/request-otp',
            {
              email,
              fullName: `${firstName} ${lastName}`,
              module: 'CONTENT-AI-SETUP',
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          );
          setCode('');
          setStep(StepEnum.VERIFY_OTP); // Move to next step only if email is valid
          trackAnalyticsEvent({
            eventName: 'Viewed - Verify Otp Screen',
            payload: {
              label: 'Viewed - Verify Otp Screen',
            },
          });
        }
      }
      setLoading(false);
    } else if (step === StepEnum.DETAILS) {
      if (!firstName) {
        newErrorMessage.firstName = '* Required';
        newError.firstName = true;
      } else {
        newErrorMessage.firstName = '';
        newError.firstName = false;
      }

      if (!lastName) {
        newErrorMessage.lastName = '* Required';
        newError.lastName = true;
      } else {
        newErrorMessage.lastName = '';
        newError.lastName = false;
      }

      if (!domain) {
        newErrorMessage.domain = '* Required';
        newError.domain = true;
      } else if (!isValidDomain(domain)) {
        newErrorMessage.domain = 'Invalid Domain';
        newError.domain = true;
      } else {
        newErrorMessage.domain = '';
        newError.domain = false;
      }

      if (!checked) {
        setCheckboxError(' Please indicate that you have read and agree to the Terms of Use and Privacy Policy!');
      }

      allValid = allValid && !newError.firstName && !newError.lastName && !newError.domain && checked;
      if (allValid) {
        try {
          setLoading(true);
          const plan_id = sessionStorage.getItem('qttr-plan-selected');
          const isInternalUser = ['mahesh.auti.ext@quattr.com', 'sanjoli.arora@quattr.com'].includes(email);
          if (usedCorpEmail) {
            if (!isDomainMatch(email, domain) && !isInternalUser) {
              if (window.analytics) {
                window.analytics.track('Forced Manual Request due to Domain Mismatch', {
                  email: email,
                  name: '',
                  schema: '',
                  instance_type: 'Content AI',
                  user_type: CONTENT_AI_USER_TYPE,
                });
              } else {
                const payload = {
                  email: email,
                  name: '',
                  schema: '',
                  instance_type: 'Content AI',
                  user_type: CONTENT_AI_USER_TYPE,
                };
                segmentEventApi('Forced Manual Request due to Domain Mismatch', payload, 'track');
              }
              await axios.post(
                '/api/join-content-ai/force-manual-request',
                {
                  domain,
                  plan_id,
                },
                {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                }
              );
              localStorage.setItem('signup-request-submitted', 'true');
              window.location.href = `https://auth.quattr.com/v2/logout?client_id=${
                process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID
              }&returnTo=${encodeURIComponent(
                `${process.env.NEXT_PUBLIC_HOST_URL}/get-started?tab=start-free-trial&&step=${StepEnum.CONFIRMATION}`
              )}`;
              return;
            }
            // domain matches
            if (window.analytics) {
              window.analytics.track('Auto Submitted Request', {
                email: email,
                name: '',
                schema: '',
                instance_type: 'Content AI',
                user_type: CONTENT_AI_USER_TYPE,
              });
            } else {
              const payload = {
                email: email,
                name: '',
                schema: '',
                instance_type: 'Content AI',
                user_type: CONTENT_AI_USER_TYPE,
              };
              segmentEventApi('Auto Submitted Request', payload, 'track');
            }
            await axios.post(
              '/api/join-content-ai/setup-user',
              {
                domain,
                plan_id,
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                },
              }
            );
            setUserAttribute('signup_route', 'Request auto submit');

            window.location.href = '/user-auth';
            return;
          }
          // manual request
          if (isCorporateAndValidEmail(email) && isDomainMatch(email, domain)) {
            if (window.analytics) {
              window.analytics.track('shown verify Email screen', {
                email: email,
                name: '',
                schema: '',
                instance_type: 'Content AI',
                user_type: CONTENT_AI_USER_TYPE,
              });
            } else {
              const payload = {
                email: email,
                name: '',
                schema: '',
                instance_type: 'Content AI',
                user_type: CONTENT_AI_USER_TYPE,
              };
              segmentEventApi('shown verify Email screen', payload, 'track');
            }
            await axios.post(
              '/api/join-content-ai/request-otp',
              {
                email,
                fullName: `${firstName} ${lastName}`,
                module: 'CONTENT-AI-SETUP',
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                },
              }
            );
            setStep(StepEnum.VERIFY_OTP);
            setLoading(false);
          } else {
            if (window.analytics) {
              window.analytics.track('Submitted Manual Request', {
                email: email,
                name: '',
                schema: '',
                instance_type: 'Content AI',
                user_type: CONTENT_AI_USER_TYPE,
              });
            } else {
              const payload = {
                email: email,
                name: '',
                schema: '',
                instance_type: 'Content AI',
                user_type: CONTENT_AI_USER_TYPE,
              };
              segmentEventApi('Submitted Manual Request', payload, 'track');
            }
            localStorage.setItem('signup-request-submitted', 'true');
            await axios.post(
              '/api/join-content-ai',
              {
                firstName: firstName,
                lastName: lastName,
                email: email,
                domain: domain,
                page_source: 'get-started',
                // selectedPlan
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                },
              }
            );
            setUserAttribute('signup_route', 'Manual Submission');
            window.location.href = `https://auth.quattr.com/v2/logout?client_id=${
              process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID
            }&returnTo=${encodeURIComponent(
              `${process.env.NEXT_PUBLIC_HOST_URL}/get-started?tab=start-free-trial&&step=${StepEnum.CONFIRMATION}`
            )}`;
          }
          setUserAttribute('domain', domain);
        } catch (error) {
          console.error(
            'Error While Creating User :',
            get(error, 'response.data.errorMsg') || get(error, 'response.data.data') || error
          );
          setApiError(
            get(error, 'response.data.errorMsg') ||
              get(error, 'response.data.data') ||
              'Oops Something Went Wrong. Please Try again!'
          );
          setLoading(false);
          if (window.analytics) {
            window.analytics.track('Encountered An error while setup', {
              email: email,
              name: '',
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              error:
                get(error, 'response.data.errorMsg') ||
                get(error, 'response.data.data') ||
                'Oops Something Went Wrong. Please Try again!',
            });
          } else {
            const payload = {
              email: email,
              name: '',
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
            };
            segmentEventApi('Encountered An error while setup', payload, 'track');
          }
        } finally {
          // nothing here
        }
      }
    }
    setErrorMessage(newErrorMessage);
    setError(newError);
  };

  const handleAutoLogin = async (password) => {
    try {
      const state = uuidv4(); // Generates a new, unique state for each session
      sessionStorage.setItem('auth_state', state); // Store state in sessionStorage for later validation

      var auth0Obj = new auth0.WebAuth({
        domain: process.env.NEXT_PUBLIC_AUTH0_ISSUER_BASE_URL,
        clientID: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID,
        connection: 'qwa-users-prod-db',
        scope: 'openid profile email',
        audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE,
        responseType: 'code',
        redirectUri: `${process.env.NEXT_PUBLIC_HOST_URL}/user-auth`,
        state: state,
      });

      let payload = { email: email };
      const result = await auth0Obj.login({
        email: payload.email,
        realm: 'qwa-users-prod-db',
        password: password,
        onRedirecting: (doAuth) => {
          doAuth();
        },
      });

      if (window.analytics) {
        window.analytics.identify(`${payload?.email}`, {
          email: payload?.email,
        });
        window.analytics.track(`Auto Login Success`, {
          option: `Auto Login Success`,
          email: payload?.email,
          isQwaDashboard: true,
        });
      } else {
        segmentEventApi(
          `Auto Login Success`,
          {
            option: `Auto Login Success`,
            email: payload?.email,
            isQwaDashboard: true,
          },
          'track'
        );
      }
    } catch (error) {
      console.error('Error', error);
      if (window.analytics) {
        window.analytics.track(`Unable to Auto Login`, {
          option: `Auto Login Error`,
          email: email,
          isQwaDashboard: false,
        });
      } else {
        segmentEventApi(
          `Unable to Auto Login`,
          {
            option: `Auto Login Error`,
            email: email,
            isQwaDashboard: false,
          },
          'track'
        );
      }
      router.push('/login');
    } finally {
      setLoading(false);
    }
  };

  const sendSlackMessageIfFails = async (error, email) => {
    try {
      const isPlainObject = (obj) => {
        return Object.prototype.toString.call(obj) === '[object Object]';
      };
      const fields = [
        {
          title: 'Error Message',
          value: error.message || 'Unknown error',
          short: false,
        },
        {
          title: 'Stack Trace',
          value: `\`\`\`${error.stack || 'No stack trace available'}\`\`\``,
          short: false,
        },
        {
          title: 'User Email',
          value: email || 'No email provided',
          short: false,
        },
      ];

      if (error.response) {
        fields.push({
          title: 'Response Status',
          value: `${error.response.status}`,
          short: true,
        });

        if (isPlainObject(error.response.data)) {
          fields.push({
            title: 'Response Data',
            value: `\`\`\`${JSON.stringify(error.response.data, null, 2)}\`\`\``,
            short: false,
          });
        } else if (typeof error.response.data === 'string' && !error.response.data.startsWith('<')) {
          fields.push({
            title: 'Response Data',
            value: `\`\`\`${error.response.data}\`\`\``,
            short: false,
          });
        }
      } else if (error.request) {
        fields.push({
          title: 'Request',
          value: `\`\`\`${JSON.stringify(error.request, null, 2)}\`\`\``,
          short: false,
        });
      }
      const payload = {
        text: `Error While Content Ai Onboarding`,
        attachments: [
          {
            color: 'danger',
            fields: fields,
          },
        ],
      };
      await axios.post('/api/post_slack_message', { payload: payload });
    } catch (error: any) {
      const payload = {
        text: `Error sending slack message on get all daypass link fail`,
        attachments: [
          {
            color: 'danger',
            fields: [
              {
                title: 'Error Message',
                value: error.message || 'Unknown error',
                short: false,
              },
            ],
          },
        ],
      };
      console.error(`Error :: sending slack message on Content Ai Onboarding fail :: ${error}`);
      await axios.post('/api/post_slack_message', { payload: payload });
    }
  };

  const setupContentAiAccount = async (password) => {
    try {
      setLoading(true);
      if (email && password && domain && firstName && lastName) {
        if (window.analytics) {
          window.analytics.track('ButtonClick - Create Account After Password Set', {
            email: email,
            firstName: firstName,
            lastName: lastName,
            name: `${firstName} ${lastName}`,
            schema: '',
            instance_type: 'Content AI',
            user_type: CONTENT_AI_USER_TYPE,
          });
        } else {
          const payload = {
            email: email,
            firstName: firstName,
            lastName: lastName,
            name: `${firstName} ${lastName}`,
            schema: '',
            instance_type: 'Content AI',
            user_type: CONTENT_AI_USER_TYPE,
          };
          segmentEventApi('ButtonClick - Create Account After Password Set', payload, 'track');
        }
        // create content ai user with free tools access.
        const res = await axios.post(
          '/api/join-content-ai/setup-content-ai-user',
          {
            email,
            password,
            firstName,
            lastName,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (res?.data?.data === 'The user already exists.') {
          if (window.analytics) {
            window.analytics.track('The User Already Exists.', {
              email: email,
              firstName: firstName,
              lastName: lastName,
              name: `${firstName} ${lastName}`,
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              isQwaDashboard: false,
            });
          } else {
            const payload = {
              email: email,
              firstName: firstName,
              lastName: lastName,
              name: `${firstName} ${lastName}`,
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              isQwaDashboard: false,
            };
            segmentEventApi('The User Already Exists.', payload, 'track');
          }
          setStep(StepEnum.ACCOUNT_ALREADY_EXIST);
        } else if (res?.data?.data?.created_at) {
          if (window.analytics) {
            window.analytics.track('Account Created Successfully', {
              email: email,
              firstName: firstName,
              lastName: lastName,
              name: `${firstName} ${lastName}`,
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              isQwaDashboard: false,
            });
          } else {
            const payload = {
              email: email,
              firstName: firstName,
              lastName: lastName,
              name: `${firstName} ${lastName}`,
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              isQwaDashboard: false,
            };
            segmentEventApi('Account created successfully', payload, 'track');
          }
          setUserAttribute('signup_route', 'Corporate email verification');
          setFullPageContentAiLoader(true);
          await handleAutoLogin(password);
        } else if (res?.data?.data === 'User metadata updated successfully') {
          if (window.analytics) {
            window.analytics.track('User metadata updated successfully', {
              email: email,
              firstName: firstName,
              lastName: lastName,
              name: `${firstName} ${lastName}`,
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              reason: 'tools user trying content ai signup',
              isQwaDashboard: false,
            });
          } else {
            const payload = {
              email: email,
              firstName: firstName,
              lastName: lastName,
              name: `${firstName} ${lastName}`,
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              reason: 'tools user trying content ai signup',
              isQwaDashboard: false,
            };
            segmentEventApi('User metadata updated successfully', payload, 'track');
          }
          setStep(StepEnum.ACCOUNT_ALREADY_EXIST);
        } else {
          if (window.analytics) {
            window.analytics.track('Unable to Create Content Ai Account', {
              email: email,
              firstName: firstName,
              lastName: lastName,
              name: `${firstName} ${lastName}`,
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              reason: 'Something Went Wrong, While Creating Content Ai Account',
            });
          } else {
            const payload = {
              email: email,
              firstName: firstName,
              lastName: lastName,
              name: `${firstName} ${lastName}`,
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              reason: 'Something Went Wrong, While Creating Content Ai Account',
            };
            segmentEventApi('Unable to Create Content Ai Account', payload, 'track');
          }
          setApiError('Oops Something Went Wrong. Please Try again!');
        }
      }
    } catch (error) {
      console.error(
        'Error While Creating User :',
        get(error, 'response.data.errorMsg') || get(error, 'response.data.data') || error
      );
      setApiError(
        get(error, 'response.data.errorMsg') ||
          get(error, 'response.data.data') ||
          'Oops Something Went Wrong. Please Try again!'
      );
      setLoading(false);

      sendSlackMessageIfFails(error, email);

      if (window.analytics) {
        window.analytics.track('Encountered An error while setup', {
          email: email,
          name: '',
          schema: '',
          instance_type: 'Content AI',
          user_type: CONTENT_AI_USER_TYPE,
          error:
            get(error, 'response.data.errorMsg') ||
            get(error, 'response.data.data') ||
            'Oops Something Went Wrong. Please Try again!',
        });
      } else {
        const payload = {
          email: email,
          name: '',
          schema: '',
          instance_type: 'Content AI',
          user_type: CONTENT_AI_USER_TYPE,
        };
        segmentEventApi('Encountered An error while setup', payload, 'track');
      }
      setFullPageContentAiLoader(false);
    } finally {
      setLoading(false);
    }
  };
  const handleResendCode = async () => {
    try {
      trackAnalyticsEvent({
        eventName: 'clicked on resend OTP',
        payload: {
          label: 'clicked on resend OTP',
        },
      });
      setLoading(true);
      await axios.post(
        '/api/join-content-ai/request-otp',
        {
          email,
          fullName: `${firstName} ${lastName}`,
          module: 'CONTENT-AI-SETUP',
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    } catch (error) {
      console.log('error ', error);
    } finally {
      setLoading(false);
    }
  };
  const verifyOtp = async () => {
    const newError = { ...error };
    const newErrorMessage = { ...errorMessage };
    trackAnalyticsEvent({
      eventName: 'Clicked - Verify OTP',
      payload: {
        label: 'Clicked - Verify OTP',
      },
    });
    try {
      if (!code) {
        newErrorMessage.code = '* Required';
        newError.code = true;
      } else {
        newErrorMessage.code = '';
        newError.code = false;
        trackAnalyticsEvent({
          eventName: 'Entered Code',
          eventFor: 'customButton',
          payload: {
            label: 'Entered Code',
          },
        });
      }
      setLoading(true);
      const res = await axios.post(
        '/api/join-content-ai/verify-otp',
        {
          email,
          otp: code,
          fullName: `${firstName} ${lastName}`,
          firstName,
          lastName,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      trackAnalyticsEvent({
        eventName: 'Verified Email with OTP',
        payload: {
          label: 'Verified Email with OTP',
        },
      });
      if (res?.data?.success === true) {
        if (res?.data?.isExistingUser === true) {
          setStep(StepEnum.ACCOUNT_ALREADY_EXIST);
          trackAnalyticsEvent({
            eventName: 'User Already Exist',
            payload: {
              label: 'User Already Exist',
            },
          });
        } else {
          setUserAttribute('last_verified_at', new Date().toISOString());
          setStep(StepEnum.CREATE_PASSWORD);
          trackAnalyticsEvent({
            eventName: 'Viewed - Set Password Screen',
            payload: {
              label: 'Viewed - Set Password Screen',
            },
          });
        }
      }
    } catch (error) {
      console.error('error : verifyOtp', error);
      newErrorMessage.code = 'Invalid OTP';
      newError.code = true;
      trackAnalyticsEvent({
        eventName: 'Entered Invalid OTP',
        payload: {
          label: 'Entered Invalid OTP',
        },
      });
    } finally {
      setLoading(false);
    }
    setErrorMessage(newErrorMessage);
    setError(newError);
  };
  const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [reEnteredPassword, setReEnteredPassword] = useState('');
    const [error, setError] = useState<{ password?: boolean; reEnteredPassword?: boolean }>({});
    const [errorMessage, setErrorMessage] = useState<{
      password?: string;
      reEnteredPassword?: string;
    }>({});

    const validatePassword = (password) => {
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumbers = /\d/.test(password);
      const hasNonalphas = /\W/.test(password);
      const isValidLength = password.length >= 8;
      return hasUpperCase && hasLowerCase && hasNumbers && hasNonalphas && isValidLength;
    };

    const passwordsMatch = (password, reEnteredPassword) => {
      // Check if reEnteredPassword exists and if it matches the current password
      const passwordMatch = reEnteredPassword && password ? password === reEnteredPassword : false;
      return passwordMatch;
    };

    const handlePasswordChange = (e) => {
      const newPassword = e.target.value;
      setPassword(newPassword);
      if (!validatePassword(newPassword)) {
        setError({ ...error, password: true });
        setErrorMessage({
          ...errorMessage,
          password:
            'Password must be at least 8 characters long, include uppercase and lowercase letters, numbers, and special characters.',
        });
      } else {
        setError({ ...error, password: false });
        setErrorMessage({ ...errorMessage, password: '' });
      }
    };

    useEffect(() => {
      if (password && reEnteredPassword && !passwordsMatch(password, reEnteredPassword)) {
        setError({ ...error, reEnteredPassword: true });
        setErrorMessage({ ...errorMessage, reEnteredPassword: 'Passwords do not match.' });
      } else {
        setError({ ...error, reEnteredPassword: false });
        setErrorMessage({ ...errorMessage, reEnteredPassword: '' });
      }
    }, [password, reEnteredPassword]);

    const handleReEnteredPasswordChange = (e) => {
      const newReEnteredPassword = e.target.value;
      setReEnteredPassword(newReEnteredPassword);
      if (!password) {
        setError({ ...error, reEnteredPassword: true });
        setErrorMessage({ ...errorMessage, reEnteredPassword: 'Passwords do not match.' });
      }
    };

    return (
      <Paper className={`${classes.signUpCard} ${classes.hideCreditCardMessage}`}>
        <Typography variant="h5" component="h2" className={parentClasses.heading}>
          Set your password
        </Typography>
        {email ? (
          <>
            <Typography className={classes.signUpSubHeading}>We are creating account for {email}</Typography>
            <Typography className={classes.changeEmailAddress} onClick={() => setStep(StepEnum.SIGN_UP)}>
              Change Email Address
            </Typography>
          </>
        ) : null}
        <br />
        <CustomTextField
          label="Set a new password"
          value={password}
          type="password"
          error={error?.password}
          errorMessage={errorMessage?.password}
          onChange={handlePasswordChange}
        />
        <CustomTextField
          label="Re-enter new password"
          value={reEnteredPassword}
          type="password"
          error={error?.reEnteredPassword}
          errorMessage={errorMessage?.reEnteredPassword}
          onChange={handleReEnteredPasswordChange}
        />
        <Button
          fullWidth
          variant="contained"
          disabled={
            loading ||
            error.password ||
            error.reEnteredPassword ||
            !password ||
            !reEnteredPassword ||
            password !== reEnteredPassword
          }
          color="primary"
          className={`${classes.signUpButton} ${classes.dynamicWidthBtn}`}
          onClick={() => setupContentAiAccount(password)}
        >
          {loading ? (
            <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
              <path id="one" d="M5,25H0V0h5V25z" />
              <path id="two" d="M15,25h-5V0h5V25z" />
              <path id="three" d="M25,25h-5V0h5V25z" />
            </svg>
          ) : null}
          {loading ? 'Please wait...' : 'Create Account'}
        </Button>
        {apiError ? (
          <p className={`${parentClasses.subText} ${parentClasses.red}`}>
            {apiError.includes('[object Object]') ? 'Something Went wrong! Please try again' : apiError}
          </p>
        ) : null}
      </Paper>
    );
  };
  if (step === StepEnum.CREATE_PASSWORD) {
    return <ResetPassword />;
  }
  if (step === StepEnum.ACCOUNT_ALREADY_EXIST) {
    return (
      <Paper className={`${classes.signUpCard} ${classes.hideCreditCardMessage}`}>
        <Typography variant="h5" component="h2" className={parentClasses.heading}>
          You have an account with Quattr!
        </Typography>
        {email ? (
          <>
            <Typography className={classes.alreadyExistHeading}>
              {' '}
              <b>Looks like this email address has a Quattr account. Login to continue</b>
            </Typography>
          </>
        ) : null}

        <br />

        <Button
          fullWidth
          variant="contained"
          disabled={loading}
          color="primary"
          className={`${classes.signUpButton} ${classes.dynamicWidthBtn}`}
          onClick={() => {
            if (window.analytics) {
              window.analytics.track(`Clicked On Retry Login`, {
                option: `Clicked On Retry Login`,
                isQwaDashboard: false,
                current_page: '/get-started',
                reason: 'Account Already Exist',
              });
            } else {
              segmentEventApi(
                `Clicked On Retry Login`,
                {
                  option: `Auto Login Error`,
                  isQwaDashboard: false,
                  current_page: '/get-started',
                  reason: 'Account Already Exist',
                },
                'track'
              );
            }

            router.push('/login');
          }}
        >
          Login
        </Button>
        <Typography variant="caption" className={classes.signUpSubHeading}>
          Want to create new account? <br />
          <span
            style={{ color: '#51D497', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => {
              if (window.analytics) {
                window.analytics.track(`Clicked On Choose a Different Email`, {
                  option: `Clicked On Retry Login`,
                  isQwaDashboard: false,
                  current_page: '/get-started',
                  reason: 'Account Already Exist',
                });
              } else {
                segmentEventApi(
                  `Clicked On Choose a Different Email`,
                  {
                    option: `Auto Login Error`,
                    isQwaDashboard: false,
                    current_page: '/get-started',
                    reason: 'Account Already Exist',
                  },
                  'track'
                );
              }
              setStep(StepEnum.SIGN_UP);
            }}
          >
            Change Email Address
          </span>
        </Typography>

        {apiError ? (
          <p className={`${parentClasses.subText} ${parentClasses.red}`}>
            {apiError.includes('[object Object]') ? 'Something Went wrong! Please try again' : apiError}
          </p>
        ) : null}
      </Paper>
    );
  }
  if (step === StepEnum.VERIFY_OTP) {
    return (
      <Paper className={`${classes.signUpCard} ${classes.hideCreditCardMessage}`}>
        <Typography variant="h5" component="h2" className={parentClasses.heading}>
          Verify Your Email
        </Typography>
        <Typography className={classes.loginText}>Head to your inbox & copy+paste the code below</Typography>
        <br />
        <div>
          <CustomTextField
            label="Enter Code"
            value={code}
            placeholder="000000"
            fullWidth
            whiteBg
            error={error?.code}
            isOtp
            errorMessage={errorMessage?.code}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setCode(e.target.value);
            }}
          />

          <div className={questionStyles.otherRoleTextContainer}>
            <Button
              fullWidth
              variant="outlined"
              disabled={loading}
              style={{
                borderRadius: '4.2px',
                border: '1px solid #1D3557',
                backgroundColor: '#fff',
              }}
              color="primary"
              className={`${classes.signUpButton} ${classes.dynamicWidthBtn} ${classes.outlined}`}
              onClick={handleResendCode}
            >
              {loading ? (
                <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                  <path id="one" d="M5,25H0V0h5V25z" />
                  <path id="two" d="M15,25h-5V0h5V25z" />
                  <path id="three" d="M25,25h-5V0h5V25z" />
                </svg>
              ) : null}
              {loading ? 'Please wait...' : 'Resend Code'}
            </Button>

            <Button
              fullWidth
              variant="contained"
              disabled={loading}
              color="primary"
              className={`${classes.signUpButton} ${classes.dynamicWidthBtn}`}
              onClick={verifyOtp}
            >
              {loading ? (
                <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                  <path id="one" d="M5,25H0V0h5V25z" />
                  <path id="two" d="M15,25h-5V0h5V25z" />
                  <path id="three" d="M25,25h-5V0h5V25z" />
                </svg>
              ) : null}
              {loading ? 'Please wait...' : 'Verify'}
            </Button>
          </div>
        </div>
      </Paper>
    );
  }
  if (step === StepEnum.CONFIRMATION) {
    return (
      <Paper className={`${classes.signUpCard} ${classes.hideCreditCardMessage}`}>
        <Typography variant="h5" component="h2" className={parentClasses.heading}>
          {isRequestApproved ? 'Your request has been already approved!' : 'Quattr is reviewing your request!'}
        </Typography>
        {/* <br /> */}
        <Typography className={classes.loginText}>
          <br />
          {isRequestApproved
            ? 'Please check your inbox for an activation email. '
            : 'Please keep an eye out for an email about your request.'}
          <br />
          <br />
          {isRequestApproved
            ? 'If you have already activated your account, you can Login using your email and password by clicking the following button.'
            : 'In meantime, explore our free AI tools'}
        </Typography>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading}
          className={`${classes.signUpButton}`}
          onClick={() => {
            if (isRequestApproved) {
              if (window.analytics) {
                window.analytics.track('Clicked on Login');
              } else {
                const payload = {
                  email: email,
                  name: '',
                  schema: '',
                  instance_type: 'Content AI',
                  user_type: CONTENT_AI_USER_TYPE,
                };
                segmentEventApi('Clicked on Login', payload, 'track');
              }

              window.location.href = `https://auth.quattr.com/v2/logout?client_id=${
                process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID
              }&returnTo=${encodeURIComponent(`${process.env.NEXT_PUBLIC_HOST_URL}/login`)}`;
            } else {
              if (window.analytics) {
                window.analytics.track('Clicked on See All Free AI Tools');
              } else {
                const payload = {
                  email: email,
                  name: '',
                  schema: '',
                  instance_type: 'Content AI',
                  user_type: CONTENT_AI_USER_TYPE,
                };
                segmentEventApi('Clicked on See All Free AI Tools', payload, 'track');
              }

              if (window && postRedirects) {
                window.parent.postMessage({ action: 'redirectURL', url: '/free-tools' }, '*');
              } else {
                router.push('/free-tools');
              }
            }
          }}
        >
          {' '}
          {isRequestApproved ? 'Login' : 'See All Free AI Tools'}
        </Button>
        <Typography className={classes.loginText} style={{ fontWeight: 700, fontSize: '12px' }}>
          Or Learn More About{' '}
          <a
            href={`/`}
            className={classes.loginLink}
            onClick={(e) => {
              e.preventDefault();
              trackAnalyticsEvent({
                eventName: 'Click',
                eventFor: 'link',
                payload: {
                  label: 'Quattr',
                  position: 'anchor text',
                },
              });
              if (window && postRedirects) {
                window.parent.postMessage({ action: 'redirectURL', url: '/' }, '*');
              } else {
                router.push('/');
              }
            }}
            style={{ fontWeight: 700, fontSize: '12px', textDecorationLine: 'underline' }}
          >
            Quattr
          </a>
        </Typography>
      </Paper>
    );
  }
  return step === StepEnum.SIGN_UP ? (
    <Paper className={`${classes.signUpCard}`}>
      <Typography variant="h5" component="h2" className={parentClasses.heading}>
        {headingText ? headingText : `Create your account`}
      </Typography>
      <Typography className={classes.loginText}>
        Already have an account?{' '}
        {postRedirects ? (
          <a
            href="/login"
            className={classes.loginLink}
            onClick={(e) => {
              e.preventDefault();
              if (window) {
                window.parent.postMessage({ action: 'redirectURL', url: '/login' }, '*');
              }
            }}
          >
            Log in
          </a>
        ) : (
          <a href="/login" className={classes.loginLink}>
            Log in
          </a>
        )}
      </Typography>
      <Button
        className={`${classes.signUpWithGoogle} mt-30`}
        onClick={() => {
          setSignUpWithGoogleLoader(true);
          if (window.analytics) {
            window.analytics.track('ButtonClick - Signup With Google', { isQwaDashboard: false });
          } else {
            const payload = {
              email: email,
              name: '',
              schema: '',
              instance_type: 'Content AI',
              user_type: CONTENT_AI_USER_TYPE,
              label: 'signup with Google',
              isQwaDashboard: false,
            };
            segmentEventApi('ButtonClick', payload, 'track');
          }
          if (window && postRedirects) {
            trackAnalyticsEvent({
              eventName: `Redirected to Google Verify`,
              payload: {
                label: `Redirected to Google Verify`,
                fromPath: '/get-started?tab=start-free-trial',
              },
            });
            window.parent.postMessage({ action: 'redirectURL', url: '/api/google-signup' }, '*');
          } else {
            trackAnalyticsEvent({
              eventName: `Redirected to Google Verify`,
              payload: {
                label: `Redirected to Google Verify`,
                fromPath: '/get-started?tab=start-free-trial',
              },
            });
            router.push('/api/google-signup');
          }
        }}
        disabled={signUpWithGoogleLoader}
      >
        {signUpWithGoogleLoader ? (
          <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
            <path id="one" d="M5,25H0V0h5V25z" />
            <path id="two" d="M15,25h-5V0h5V25z" />
            <path id="three" d="M25,25h-5V0h5V25z" />
          </svg>
        ) : null}
        <svg
          className={classes.svgStyle}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.04 12.6777C23.04 11.8623 22.9668 11.0782 22.8309 10.3254H12V14.7738H18.1891C17.9225 16.2113 17.1123 17.4293 15.8943 18.2448V21.1302H19.6109C21.7855 19.1282 23.04 16.18 23.04 12.6777Z"
            fill={signUpWithGoogleLoader ? 'gray' : '#4285F4'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9999 23.9162C15.1049 23.9162 17.7081 22.8864 19.6108 21.1301L15.8943 18.2446C14.8645 18.9346 13.5472 19.3423 11.9999 19.3423C9.00471 19.3423 6.46948 17.3194 5.56516 14.6012H1.72311V17.5807C3.61539 21.3392 7.50448 23.9162 11.9999 23.9162Z"
            fill={signUpWithGoogleLoader ? '#808080ba' : '#34A853'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.56523 14.6015C5.33523 13.9115 5.20455 13.1745 5.20455 12.4165C5.20455 11.6585 5.33523 10.9215 5.56523 10.2315V7.25195H1.72318C0.944318 8.80445 0.5 10.5608 0.5 12.4165C0.5 14.2722 0.944318 16.0285 1.72318 17.581L5.56523 14.6015Z"
            fill={signUpWithGoogleLoader ? 'gray' : '#FBBC05'}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9999 5.49025C13.6883 5.49025 15.2043 6.07047 16.3961 7.21002L19.6945 3.91161C17.7029 2.05593 15.0997 0.916382 11.9999 0.916382C7.50448 0.916382 3.61539 3.49343 1.72311 7.25184L5.56516 10.2314C6.46948 7.5132 9.00471 5.49025 11.9999 5.49025Z"
            fill={signUpWithGoogleLoader ? '#808080ba' : '#EA4335'}
          />
        </svg>
        Sign up with Google
      </Button>
      <Box className={classes.dividerContainer}>
        <Divider className={classes.divider} />
        <Typography variant="caption" className={classes.dividerText}>
          Or, sign up with your email
        </Typography>
        <Divider className={classes.divider} />
      </Box>
      <Grid container spacing={2} className="mt-20">
        <Grid item sm={6} xs={12}>
          <CustomTextField
            label="First name"
            value={firstName}
            placeholder="John"
            error={error?.firstName}
            errorMessage={errorMessage.firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <CustomTextField
            label="Last name"
            value={lastName}
            placeholder="Doe"
            error={error?.lastName}
            errorMessage={errorMessage.lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </Grid>
      </Grid>
      <CustomTextField
        label="Work email"
        value={email}
        type="email"
        error={error?.email}
        errorMessage={errorMessage?.email}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setEmail(e.target.value);
        }}
      />
      <Typography variant="body2" className={classes.secondaryText}>
        <b>Note:</b> Select the email address connected to your domain's <b> Google Search Console (GSC)</b>.
      </Typography>
      <div className={classes.termsCheckBox}>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={handleCheckboxChange}
              style={{ color: checked ? '#51D497' : undefined, paddingTop: '0px' }}
              className={`${checkboxError ? parentClasses.red : ''}`}
            />
          }
          style={{ alignItems: 'start' }}
          label={
            <div
              className={` ${classes.secondaryText} ${checkboxError ? parentClasses.red : ''}`}
              style={{ fontSize: '12px' }}
            >
              <div>
                I agree to Quattr’s{' '}
                <a
                  className={`${checkboxError ? parentClasses.red : parentClasses.green} ${parentClasses.link}`}
                  href={'/content-ai/terms'}
                  onClick={(e) => {
                    e.preventDefault();
                    if (window && postRedirects) {
                      window.parent.postMessage({ action: 'redirectURL', url: '/content-ai/terms' }, '*');
                    } else {
                      if (window) {
                        e.preventDefault();
                        window.open('/content-ai/terms', '_blank');
                      } else {
                        router.push('/content-ai/terms');
                      }
                    }
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: '12px' }}
                >
                  {' '}
                  terms of service
                </a>{' '}
                &amp;{' '}
                <a
                  className={`${checkboxError ? parentClasses.red : parentClasses.green} ${parentClasses.link}`}
                  href={'/privacy-policy'}
                  onClick={(e) => {
                    e.preventDefault();
                    if (window && postRedirects) {
                      window.parent.postMessage({ action: 'redirectURL', url: '/privacy-policy' }, '*');
                    } else {
                      if (window) {
                        e.preventDefault();
                        window.open('/privacy-policy', '_blank');
                      } else {
                        router.push('/privacy-policy');
                      }
                    }
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: '12px' }}
                >
                  privacy policy
                </a>
                .
              </div>
            </div>
          }
        />
      </div>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        disabled={loading || !firstName || !lastName || !email || !checked}
        className={classes.signUpButton}
        onClick={() => handleSignUpNoWClick(StepEnum.SIGN_UP)}
      >
        {loading ? (
          <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
            <path id="one" d="M5,25H0V0h5V25z" />
            <path id="two" d="M15,25h-5V0h5V25z" />
            <path id="three" d="M25,25h-5V0h5V25z" />
          </svg>
        ) : null}
        Verify email
      </Button>
    </Paper>
  ) : null;
};

export const bookMeeting = ({ classes, setShowCalendly }) => {
  interface FieldErrors {
    firstName?: string;
    lastName?: string;
    email?: string;
    companyName?: string;
    companySize?: string;
    website?: string;
  }
  const [fields, setFields] = useState({
    firstName: '',
    lastName: '',
    email: '',
    companyName: '',
    companySize: '',
    website: 'https://',
  });
  const [errors, setErrors] = useState<FieldErrors>({
    firstName: '',
    lastName: '',
    email: '',
    companyName: '',
    companySize: '',
    website: '',
  });

  const [isLoading, setLoading] = useState(false);

  const ownClasses = useSignUpStyles();
  const rollbar = useRollbar();

  const handleFieldChange = (field, value) => {
    setFields({ ...fields, [field]: value });
    setErrors({ ...errors, [field]: '' });
  };

  const validateFields = () => {
    let tempErrors: FieldErrors = {};
    let isValid = true;

    // Email Regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // URL Regex (simplified for demonstration)
    const urlRegex = /^(https?:\/\/)?(www\.)?[a-z0-9]+(\.[a-z]+)+[\/\w .-]*\/?$/;

    if (!fields.firstName) {
      tempErrors.firstName = 'First name is required';
      isValid = false;
    }

    if (!fields.lastName) {
      tempErrors.lastName = 'Last name is required';
      isValid = false;
    }

    if (!fields.email || !emailRegex.test(fields.email)) {
      tempErrors.email = 'Enter a valid email address';
      isValid = false;
    }

    if (!fields.companyName) {
      tempErrors.companyName = 'Company name is required';
      isValid = false;
    }

    if (!fields.companySize) {
      tempErrors.companySize = 'Please select the company size';
      isValid = false;
    }

    if (!fields.website || !urlRegex.test(fields.website)) {
      tempErrors.website = 'Enter a valid website URL';
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (validateFields()) {
        setLoading(true);
        const formValues = {
          firstname: fields.firstName,
          lastname: fields.lastName,
          email: fields.email,
          company: fields.companyName,
          company_size__dropdown_: fields.companySize,
          website: fields.website,
        };
        if (setShowCalendly) {
          setShowCalendly(true);
        }
        localStorage.setItem('is_book_meeting_form_submitted', 'true');
        localStorage.setItem('book-demo-email', fields.email);
        localStorage.setItem('book-demo-name', `${fields.firstName} ${fields.lastName}`);
        if (window.analytics) {
          window.analytics.identify(fields.email, {
            email: fields.email,
            name: `${fields.firstName} ${fields.lastName}`,
            schema: '',
            instance_type: 'Content AI',
            user_type: CONTENT_AI_USER_TYPE,
            company_name: '',
          });
        }
        trackAnalyticsEvent({
          eventName: `Submitted the book demo form`,
          payload: {
            label: `Submitted the book demo form`,
            ...formValues,
          },
        });
        if (isProductionEnv) {
          await HubSpotService.sendDataToForm(FormConfigMap.bookMeetingForm, { ...formValues }, undefined).catch(
            (error) => {
              console.error('Error sending data to HubSpot in the Request a Demo form', error);
              rollbar.warning('Error sending data to HubSpot in the Request a Demo form', error);
            }
          );
        }
      }
    } catch (error) {
      console.error('handleSubmit::', error);
    }
  };

  return (
    <div className={classes.innerWrap}>
      <Paper
        className={`${ownClasses.signUpCard} ${ownClasses.hideCreditCardMessage}`}
        style={{ padding: '19px 28px 3px' }}
      >
        <Typography variant="h5" component="h2" className={classes.heading}>
          Tell us about yourself
        </Typography>
        <Grid container spacing={2} className="mt-20">
          <Grid item sm={6} xs={12}>
            <CustomTextField
              label="First name"
              value={fields.firstName}
              placeholder="John"
              error={!!errors.firstName}
              errorMessage={errors.firstName}
              onChange={(e) => handleFieldChange('firstName', e.target.value)}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <CustomTextField
              label="Last name"
              value={fields.lastName}
              placeholder="Doe"
              error={!!errors.lastName}
              errorMessage={errors.lastName}
              onChange={(e) => handleFieldChange('lastName', e.target.value)}
            />
          </Grid>
        </Grid>
        <CustomTextField
          label="Email address"
          value={fields.email}
          placeholder="john.doe@example.com"
          error={!!errors.email}
          errorMessage={errors.email}
          onChange={(e) => handleFieldChange('email', e.target.value)}
        />
        <CustomTextField
          label="Company name"
          value={fields.companyName}
          placeholder="Example Corp"
          error={!!errors.companyName}
          errorMessage={errors.companyName}
          onChange={(e) => handleFieldChange('companyName', e.target.value)}
        />
        <CustomSelect
          label="Company Size"
          value={fields.companySize}
          onChange={(e) => handleFieldChange('companySize', e.target.value)}
          error={!!errors.companySize}
          errorMessage={errors.companySize}
          info="Select the size of your company"
          options={[
            { value: '1-50 Employees', label: '1-50 employees' },
            { value: '51-250 Employees', label: '51-250 employees' },
            { value: '251-1000 Employees', label: '251-1000 employees' },
            { value: '1001+ Employees', label: '1001+ employees' },
          ]}
        />
        <CustomTextField
          label="Website domain address"
          value={fields.website}
          placeholder="https://www.example.com"
          error={!!errors.website}
          info={'Website Domain address is the home page link or URL of the website you run and operate.'}
          errorMessage={errors.website}
          onChange={(e) => handleFieldChange('website', e.target.value)}
        />
        <Button
          fullWidth
          variant="contained"
          className={`${ownClasses.signUpButton} ${ownClasses.dynamicWidthBtn}`}
          color="primary"
          disabled={isLoading}
          style={{ marginTop: '7px', textTransform: 'unset' }}
          onClick={handleSubmit}
        >
          Book a Demo
        </Button>
      </Paper>
    </div>
  );
};

const GetStarted = ({ classes, setGoBack, setFullPageContentAiLoader }) => {
  const router = useRouter();
  const plan_id = router.query.plan || 'individual-monthly';
  const request_submitted = router.query.request_submitted;
  const isNoCorpEmail = router.query.nocorp;
  useEffect(() => {
    if (plan_id && typeof plan_id == 'string') {
      sessionStorage.setItem('qttr-plan-selected', plan_id);
    }
  }, [plan_id]);
  const ownClasses = useSignUpStyles();
  if (request_submitted) {
    return (
      <div className={classes.innerWrap}>
        <div>
          <h1 className={classes.heading}>Your request has been received</h1>
          <h2 className={`${classes.heading} ${classes.heading2} ${classes.green}`}>
            The Quattr team is working on setting up your account.
          </h2>
          <p className={classes.subText}>
            Please keep an eye out for an email in your inbox. We will share your login details soon.
          </p>
        </div>
      </div>
    );
  }
  return (
    <div className={classes.innerWrap}>
      <MetaTagGenerator
        metaUrl={`${process.env.NEXT_PUBLIC_HOST_URL}${router.asPath}`}
        metaTitle={`Get started with Quattr's Content AI`}
        metaDescription={`Sign up with your Google account now to get access to Content AI. Write, optimize, and rank high with ease and speed.`}
      />
      <OnboardingForm
        parentClasses={classes}
        headingText={''}
        postRedirects={false}
        setGoBack={setGoBack}
        setFullPageContentAiLoader={setFullPageContentAiLoader}
      />
    </div>
  );
};

export const getStartedWrapperStyles = makeStyles((theme) => ({
  mainWrapper: {
    display: 'flex',
    flexDirection: 'row',
    height: 'calc(100vh - 60px)',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginTop: '0px',
      height: 'unset',
    },
  },
  topHeadingsWrapper: {
    marginTop: '56px',
  },
  aiToolsMainWrapper: {
    height: '100vh',
    overflowY: 'scroll',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0px',
      height: 'unset',
      overflowY: 'unset',
      width: 'unset',
    },
  },
  tabsWrapper: {
    background: '#ECF2FC',
    textAlign: 'center',
    maxWidth: '400px',
    minWidth: '400px',
    height: '100vh',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      maxWidth: 'unset',
      minWidth: 'unset',
      width: '100%',
      height: 'unset',
    },
  },
  stickyTabsWrapper: {
    position: 'sticky',
    top: '56px',
    zIndex: 9,
  },
  headingWrapper: {
    margin: '44px 30px 24px',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 12px 0px',
    },
  },
  tabsHeading: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '140%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
      margin: '0px',
    },
  },
  secondaryText: {
    color: '#1D3557',
    fontFamily: '"Source Sans Pro"',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '140%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },
  tabs: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: 'unset',
      margin: 'auto',
      '& div ': {
        display: 'flex',
        overflow: 'hidden !important',
        flexWrap: 'wrap !important',
        justifyContent: 'center !important',
        maxWidth: '100%',
        paddingBottom: '3px',
      },
      '& .MuiTabs-scrollButtonsDesktop': {
        display: 'none !important',
      },
    },
  },
  tab: {
    textTransform: 'unset',
    minWidth: '100%',
    width: '100%',
    padding: '23px 15px 23px 23px',
    border: '2px solid #1D3557',
    opacity: 1,
    margin: '7.5px 0px',
    [theme.breakpoints.down('sm')]: {
      color: ' #1D3557',
      fontFamily: 'Source Sans Pro',
      fontWeight: 400,
      fontSize: '12px',
      minWidth: 'unset',
      width: 'unset',
      border: 'unset',
      margin: '7.5px 0px 0px',
      padding: '7px 15px',
      minHeight: 'unset',
    },
    [theme.breakpoints.down(360)]: {
      fontSize: '12px',
      padding: '5px 8px',
    },
  },
  blackCheck: {
    height: '35px',
    width: '35px',
    margin: '0px',
    marginRight: '25px',
  },
  toolsSvg: {
    height: '55px',
    width: '55px',
    margin: '0px',
    padding: '0px',
    marginRight: '25px',
  },
  tabHeading: {
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '140%',
    margin: '0px',
  },
  indicator: {
    backgroundColor: 'transparent',
  },
  tabSelected: {
    background: '#FFF',
    boxShadow: '0px 5px 4px 2px rgba(29, 53, 87, 0.25)',
    border: '2px solid #fff',
    [theme.breakpoints.down('sm')]: {
      fontWeight: 600,
      boxShadow: 'unset',
      borderRadius: '10px 10px 0 0',
    },
  },
  tabIcon: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'unset',
  },
  loaderWrapper: {
    position: 'relative',
    '& .MuiGrid-root': {
      height: 'auto',
    },
  },
  loader: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
  },
  loaderText: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 700,
    whiteSpace: 'pre-line',
  },
  loaderTextDescription: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    whiteSpace: 'pre-line',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'radial-gradient(circle, white, white 10%, rgba(255, 255, 255, 0.5) 90%, transparent)',
    zIndex: 9998,
  },
  hidden: {
    display: 'none',
  },
}));

const updateUrlParameter = (parameterName, parameterValue) => {
  // Construct a URLSearchParams object from the current URL query string
  const searchParams = new URLSearchParams(window.location.search);

  // Update the parameter value or add it if it doesn't exist
  searchParams.set(parameterName, parameterValue);

  // Construct the new URL
  const newUrl = `${window.location.pathname}?${searchParams.toString()}`;

  // Use window.history.pushState() to change the URL without reloading the page
  window.history.pushState({ path: newUrl }, '', newUrl);
};

const GetStartedWrapped = () => {
  const [tabName, setTabName] = useState('start-free-trial');
  const router = useRouter();

  useEffect(() => {
    const toolUsed = Cookies.get('ToolUsed') || false;
    if (!router.query.tab && toolUsed) {
      setTabName('ai-tools');
      setValue(2);
    }
  }, [router.query.tab]);

  const tab = router.query.tab || tabName;
  const tabIndex = tab === 'start-free-trial' ? 0 : tab === 'book-demo' ? 1 : 2;
  const [value, setValue] = React.useState(tabIndex);
  const classes = useOnboardingStyles();
  const ownClasses = getStartedWrapperStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [showCalendly, setShowCalendly] = useState(false);
  const [showToolsVerifyForm, setShowToolsVerifyForm] = useState(false);
  const [showPricingAndPlans, setShowPricingAndPlans] = useState(true);
  const [planPurchaseLoading, setPlanPurchaseLoading] = useState({});
  const [fullScreenLoader, setFullScreenLoader] = useState(false);
  const [fullPageContentAiLoader, setFullPageContentAiLoader] = useState(false);

  const session = useSession();
  const Router = useRouter();
  const { id, state } = router.query;
  let qttr_tools_auth = Cookies.get('qttr_tools_auth');
  const isFromUnlockOption = Object.keys(Router.query).includes('unlock-options');
  const isSignUpNow = Object.keys(Router.query).includes('signup-now');
  const toolState = Object.keys(Router.query).includes('toolState');

  useEffect(() => {
    const is_book_meeting_form_submitted = localStorage.getItem('is_book_meeting_form_submitted');
    if (is_book_meeting_form_submitted) {
      setShowCalendly(true);
    }
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    updateUrlParameter('tab', newValue == 1 ? 'book-demo' : newValue == 0 ? 'start-free-trial' : 'ai-tools');
    trackAnalyticsEvent({
      eventName: `Tab View - ${newValue == 1 ? 'book-demo' : newValue == 0 ? 'start-free-trial' : 'ai-tools'}`,
      payload: {
        label: `Tab View - ${newValue == 1 ? 'book-demo' : newValue == 0 ? 'start-free-trial' : 'ai-tools'}`,
        isQwaDashboard: false,
      },
    });
    if (isMobile && window.scrollY >= 90) {
      window.scrollTo(0, 90);
    } else {
      window.scrollTo(0, 0);
    }
  };

  const handleGoBack = () => {
    const previousUrl = localStorage.getItem('previousUrl');
    if (previousUrl) {
      // Modify the URL to add or update query parameters as needed
      const newUrl = new URL(previousUrl, window.location.origin);
      if (!qttr_tools_auth) {
        newUrl.searchParams.set('verifyEmail', 'true'); // Add or modify query params here
      }
      if (isFromUnlockOption) {
        newUrl.searchParams.set('unlock-options', 'true');
      } else if (isSignUpNow) {
        newUrl.searchParams.set('signup-now', 'true');
      }
      // Use Router.push or Router.replace to navigate
      Router.push(newUrl.pathname + newUrl.search);
    } else {
      // Fallback to home
      Router.push('/');
    }
  };

  const handlePlanSelection = async (plan) => {
    const qttr_tools_auth = Cookies.get('qttr_tools_auth');

    let params = {};
    try {
      if (qttr_tools_auth) {
        const [headerEncoded, payloadEncoded, signatureEncoded] = qttr_tools_auth.split('.');
        // Decode the base64-encoded payload
        const payload = JSON.parse(atob(payloadEncoded));

        params = {
          planType: plan,
          redirect_url: `${process.env.NEXT_PUBLIC_HOST_URL}/get-started?tab=ai-tools`,
          email: payload?.email,
          firstName: payload?.firstName,
          lastName: payload?.lastName,
        };
      } else {
        params = { planType: plan, redirect_url: `${process.env.NEXT_PUBLIC_HOST_URL}/get-started?tab=ai-tools` };
      }

      setPlanPurchaseLoading((prevState) => ({ ...prevState, [plan]: true }));

      const result = await axios.post('/api/join-content-ai/get-ai-paid-plan-user-link', params);

      if (result?.data?.data?.url) {
        if (window.analytics) {
          window.analytics.track(`Redirected To chargeBee For (${plan} Plan)`, {
            option: `chargeBee : ${plan} Plan`,
            isQwaDashboard: false,
          });
        } else {
          segmentEventApi(
            `Redirected To chargeBee For (${plan} Plan)`,
            {
              option: `chargeBee : ${plan} Plan`,
              isQwaDashboard: false,
            },
            'track'
          );
        }
        window.location.href = result?.data?.data?.url;
      }
    } catch (error) {
      console.error('Error :: chargebee redirect for paid tools user', error);
    } finally {
      setPlanPurchaseLoading((prevState) => ({ ...prevState, [plan]: false }));
    }
    if (window.analytics) {
      window.analytics.track(`Clicked Start Now (${plan} Plan)`, {
        option: plan,
        isQwaDashboard: false,
      });
    } else {
      segmentEventApi(
        `Clicked Start Now (${plan} Plan)`,
        {
          option: plan,
          isQwaDashboard: false,
        },
        'track'
      );
    }
  };

  const handleExistingUserVerify = async (data, email, isExistingUser) => {
    const payload = {
      email: email,
      planId: data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0].item_price_id,
      qwa_tools_subscription_status: SUBSCRIPTION_STATUS.SUBSCRIPTION_ACTIVATED,
    };
    try {
      setFullScreenLoader(true);
      if (isExistingUser) {
        setFullScreenLoader(false);
        if (window?.analytics) {
          window.analytics.track('Redirected to Login', {
            option: 'Redirected to Login',
            isQwaDashboard: false,
          });
        } else {
          segmentEventApi(
            `Redirected to Login`,
            {
              option: `Redirected to Login`,
              isQwaDashboard: false,
            },
            'track'
          );
        }
        router.push('/login');
      } else {
        setFullScreenLoader(false);
        setShowPricingAndPlans(false);
        setShowToolsVerifyForm(true);
        if (window?.analytics) {
          window.analytics.track('Viewed Set Password Screen', {
            option: 'Viewed Set Password Screen',
            userProps: payload,
            isQwaDashboard: false,
          });
        } else {
          segmentEventApi(
            `Viewed Set Password Screen`,
            {
              option: `Viewed Set Password Screen`,
              userProps: payload,
              isQwaDashboard: false,
            },
            'track'
          );
        }
      }
    } catch (error) {
      console.error('Error: handleExistingUserVerify', error);
      if (window?.analytics) {
        window.analytics.track('Error checking Existing User', {
          option: 'Error checking Existing User',
          userProps: payload,
          isQwaDashboard: false,
        });
      } else {
        segmentEventApi(
          `Error Checking Existing User`,
          {
            option: `Error checking Existing User`,
            userProps: payload,
            isQwaDashboard: false,
          },
          'track'
        );
      }
    } finally {
      setFullScreenLoader(false);
    }
  };
  const identifyAndTrack = debounce((sessionPayload, result) => {
    if (window.analytics) {
      window.analytics.identify(sessionPayload?.email, {
        email: sessionPayload?.email,
        name: `${sessionPayload?.firstName} ${sessionPayload?.lastName}`,
        schema: '',
        instance_type: 'Ai Tools',
        user_type: USER_CLASSIFICATION.QWA_TOOLS,
        company_name: '',
      });
      window.analytics.track(
        `Tools Plan Purchase Verified (${result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0].item_price_id})`,
        {
          option: `Tools Plan Purchase Verified (${result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0].item_price_id})`,
          email: result?.data?.data?.hosted_page?.content?.customer?.email,
          planId: result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0].item_price_id,
          firstName: result?.data?.data?.hosted_page?.content?.customer?.first_name,
          lastName: result?.data?.data?.hosted_page?.content?.customer?.last_name,
          isQwaDashboard: false,
        }
      );
    } else {
      segmentEventApi(
        `Tools Plan Purchase Verified (${result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0].item_price_id})`,
        {
          option: `Tools Plan Purchase Verified (${result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0].item_price_id})`,
          payload: sessionPayload,
          isQwaDashboard: false,
        },
        'track'
      );
    }
    trackAnalyticsEvent({
      eventName: `Revenue tracking - Plan Purchase`,
      payload: {
        userDetails: sessionPayload,
        plan_id: result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0].item_price_id,
        $price: result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0]?.amount / 100,
        $revenue: result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0]?.amount / 100,
        $currency: 'USD', // or the appropriate currency
        $revenueType: 'Plan Purchase', // optional
        $productId: result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0].item_price_id,
        $quantity: 1,
        current_term_start: formatUnixDate(
          result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0]?.current_term_start
        ),
        current_term_end: formatUnixDate(
          result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0]?.current_term_end
        ),
        next_billing_at: formatUnixDate(
          result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0]?.next_billing_at
        ),
        label: `Revenue tracking - Plan Purchase`,
        isQwaDashboard: false,
      },
    });
  }, 3000);

  const handlePaymentVerify = async (id) => {
    try {
      setFullScreenLoader(true);
      const result = await axios.post('/api/join-content-ai/verify-ai-tools-plan', { id: id, isQwaDashboard: false });
      if (result.data) {
        const sessionPayload = {
          planId: result?.data?.data?.hosted_page?.content?.subscription?.subscription_items?.[0].item_price_id,
          email: result?.data?.data?.hosted_page?.content?.customer?.email,
          firstName: result?.data?.data?.hosted_page?.content?.customer?.first_name,
          lastName: result?.data?.data?.hosted_page?.content?.customer?.last_name,
        };
        sessionStorage.setItem('tools-user-auth', JSON.stringify(sessionPayload));
        setCookie('qttr_tools_daypass_auth', '', false, true);

        identifyAndTrack(sessionPayload, result);

        handleExistingUserVerify(
          result.data,
          result?.data?.data?.hosted_page?.content?.customer?.email,
          result?.data?.data?.isExistingUser
        );
      }
    } catch (error) {
      console.error('Error : handlePaymentVerify', error);
      if (window.analytics) {
        window.analytics.track(`Tools Plan Purchase Verification Error`, {
          option: `Tools Plan Purchase Verification Error`,
          isQwaDashboard: false,
        });
      } else {
        segmentEventApi(
          `Tools Plan Purchase Verification Error`,
          {
            option: `Tools Plan Purchase Verification Error`,
            isQwaDashboard: false,
          },
          'track'
        );
      }
    } finally {
      // setFullScreenLoader(false);
    }
  };

  useEffect(() => {
    if (id && ['succeeded', 'requested'].includes(state as string)) {
      handlePaymentVerify(id);
    }
  }, [id]);

  useEffect(() => {
    const toolsUser = sessionStorage?.getItem('tools-user-auth');
    if (toolsUser && toolState && session) {
      const sessionUser = toolsUser ? JSON.parse(toolsUser) : null;
      const sessionEmail = session?.session?.user?.email;
      const paymentEmail = sessionUser?.email;

      if (sessionEmail && paymentEmail) {
        if (sessionEmail === paymentEmail) {
          router.push('/user-auth');
        } else {
          signOut({ callbackUrl: '/get-started?tab=ai-tools&&manualLogin=true', redirect: true });
          // router.push('/get-started?tab=ai-tools&&manualLogin=true');
        }
      }
    }
  }, [session, toolState]);

  useEffect(() => {
    if (router?.query?.manualLogin === 'true') {
      setShowToolsVerifyForm(true);
      setShowPricingAndPlans(false);
      if (window.analytics) {
        window.analytics.track("Emails doesn't matching", {
          label: 'Shown manual login as payment email and google email not matching',
        });
      } else {
        const payload = {
          instance_type: USER_CLASSIFICATION.QWA_TOOLS,
          label: 'Shown manual login as payment email and google email not matching',
        };
        segmentEventApi("Emails doesn't matching", payload, 'track');
      }
    }
  }, [router]);

  const handleChangePlanClick = () => {
    setShowPricingAndPlans(true);
    setShowToolsVerifyForm(false);
  };

  return (
    <div>
      <AppBar color="transparent" elevation={0} position="fixed" className={classes.appBar}>
        <Toolbar className="dflex j-content-space-bet">
          <Link href={'/'}>
            <img
              src={
                isMobile
                  ? 'https://qwa-assets.s3.us-east-2.amazonaws.com/home-logo.svg'
                  : 'https://qwa-assets.s3.us-east-2.amazonaws.com/home-logo-white.svg'
              }
              alt="Logo"
              className={classes.logo}
            />
          </Link>
          <CloseIcon style={{ color: isMobile ? '' : '#FFF', cursor: 'pointer' }} onClick={handleGoBack} />
        </Toolbar>
      </AppBar>

      <div className={`${ownClasses.topHeadingsWrapper} ${ownClasses.mainWrapper}`}>
        <div className={ownClasses.tabsWrapper}>
          <div className={ownClasses.headingWrapper}>
            <h3 className={ownClasses.tabsHeading}>
              {isMobile ? 'How to get started?' : 'How would you like to get started?'}
            </h3>
            <Typography className={ownClasses.secondaryText}>Select the best option for your needs.</Typography>
            {isMobile && <Divider style={{ margin: '7px 20px', backgroundColor: '#757575' }} />}
          </div>
          {!isMobile ? (
            <Tabs
              orientation={isMobile ? 'horizontal' : 'vertical'}
              variant="scrollable"
              value={value}
              classes={{ indicator: ownClasses.indicator }}
              onChange={handleChange}
              className={ownClasses.tabs}
              aria-label="Responsive tabs"
            >
              <Tab
                className={ownClasses.tab}
                classes={{ selected: ownClasses.tabSelected }}
                icon={
                  isMobile ? (
                    <div className={ownClasses.tabIcon}>Content AI for Websites</div>
                  ) : (
                    <div className={ownClasses.tabIcon}>
                      <img
                        className={ownClasses.blackCheck}
                        src="https://qwa-assets.s3.us-east-2.amazonaws.com/get-started-magic-pen-large.svg"
                        alt="onboarding-background"
                      />
                      <div style={{ textAlign: 'left' }}>
                        <h4 className={ownClasses.tabHeading}>Use Content AI for Website</h4>
                        <Typography className={ownClasses.secondaryText}>
                          For Content Marketers, SEOs, Copywriters, & Business Owners.{' '}
                        </Typography>
                      </div>
                    </div>
                  )
                }
              ></Tab>
              <Tab
                className={ownClasses.tab}
                classes={{ selected: ownClasses.tabSelected }}
                icon={
                  isMobile ? (
                    <div className={ownClasses.tabIcon}>Book Demo for AI SEO Suite</div>
                  ) : (
                    <div className={ownClasses.tabIcon}>
                      <img
                        className={ownClasses.blackCheck}
                        src="https://qwa-assets.s3.us-east-2.amazonaws.com/get-started-calendar.svg"
                        alt="onboarding-background"
                      />
                      <div style={{ textAlign: 'left' }}>
                        <h4 className={ownClasses.tabHeading}>Book Demo of AI SEO Suite</h4>
                        <Typography className={ownClasses.secondaryText}>
                          SEO Platform for Enterprises, Global Brands, & Startups.{' '}
                        </Typography>
                      </div>
                    </div>
                  )
                }
              ></Tab>
              <Tab
                className={ownClasses.tab}
                classes={{ selected: ownClasses.tabSelected }}
                icon={
                  isMobile ? (
                    <div className={ownClasses.tabIcon}>Quick AI Tools</div>
                  ) : (
                    <div className={ownClasses.tabIcon}>
                      <svg
                        className={ownClasses.toolsSvg}
                        xmlns="http://www.w3.org/2000/svg"
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.97493 1.097C5.35906 0.712873 5.88005 0.49707 6.4233 0.49707H24.9606C25.5034 0.497549 26.0248 0.713485 26.4085 1.09742L31.4162 6.10512C31.6069 6.29554 31.7581 6.52172 31.8612 6.77069C31.9643 7.01967 32.0173 7.28654 32.017 7.556V17.4999C32.017 18.104 31.5274 18.5937 30.9233 18.5937C30.3192 18.5937 29.8295 18.104 29.8295 17.4999V7.61205L29.8699 7.6524C29.8572 7.63957 29.8471 7.62437 29.8401 7.60765C29.8332 7.59099 29.8296 7.57315 29.8295 7.55514V7.61205L24.9021 2.68457H24.9606C24.9239 2.68454 24.8877 2.67003 24.8617 2.64422M24.8617 2.64422L24.9021 2.68457H6.5625V2.54537C6.5625 2.58229 6.54783 2.61769 6.52173 2.6438C6.49562 2.6699 6.46021 2.68457 6.4233 2.68457H6.5625V32.3153H6.4233C6.46021 32.3153 6.49562 32.3299 6.52173 32.356C6.54784 32.3821 6.5625 32.4175 6.5625 32.4545V32.3153H16.6051C17.2092 32.3153 17.6989 32.8049 17.6989 33.409C17.6989 34.0131 17.2092 34.5028 16.6051 34.5028H6.4233C5.88006 34.5028 5.35906 34.287 4.97493 33.9028C4.5908 33.5187 4.375 32.9977 4.375 32.4545V2.54537C4.375 2.00212 4.5908 1.48113 4.97493 1.097"
                          fill="#1D3557"
                        />
                        <path
                          d="M14.8155 20.9999L18.4613 18.9583L16.4197 22.6041L18.4613 26.2499L14.8155 24.2083L11.1697 26.2499L13.2113 22.6041L11.1697 18.9583L14.8155 20.9999Z"
                          fill="#1D3557"
                        />
                        <path
                          d="M23.0247 24.9564L20.8014 22.7331L22.7331 20.8014L24.9564 23.0247L23.0247 24.9564ZM22.0862 19.954L19.9541 22.0862C19.5987 22.4233 19.5987 23.0156 19.9541 23.3709L30.5875 34.0043C30.9428 34.3597 31.5351 34.3597 31.8722 34.0043L34.0044 31.8722C34.3597 31.535 34.3597 30.9428 34.0044 30.5874L23.371 19.954C23.0156 19.5987 22.4233 19.5987 22.0862 19.954Z"
                          fill="#1D3557"
                        />
                        <path
                          d="M13.344 11.2676L8.75002 11.9592L12.3056 8.969L11.614 4.375L14.6042 7.93056L19.1982 7.239L15.6426 10.2292L16.3342 14.8232L13.344 11.2676Z"
                          fill="#1D3557"
                        />
                        <path
                          d="M22.852 16.0502L18.9583 16.6364L21.9719 14.102L21.3857 10.2083L23.9201 13.2218L27.8139 12.6357L24.8003 15.1701L25.3864 19.0638L22.852 16.0502Z"
                          fill="#1D3557"
                        />
                      </svg>
                      <div style={{ textAlign: 'left' }}>
                        <h4 className={ownClasses.tabHeading}>Start with Quick AI Tools</h4>
                        <Typography className={ownClasses.secondaryText}>
                          Complete Projects Faster with Uninterrupted Access to 19 AI Tools{' '}
                        </Typography>
                      </div>
                    </div>
                  )
                }
              ></Tab>
            </Tabs>
          ) : null}
        </div>
        <div className={isMobile ? `${ownClasses.tabsWrapper} ${ownClasses.stickyTabsWrapper}` : ownClasses.hidden}>
          {isMobile ? (
            <Tabs
              orientation={isMobile ? 'horizontal' : 'vertical'}
              variant="scrollable"
              value={value}
              classes={{ indicator: ownClasses.indicator }}
              onChange={handleChange}
              className={ownClasses.tabs}
              aria-label="Responsive tabs"
            >
              <Tab
                className={ownClasses.tab}
                classes={{ selected: ownClasses.tabSelected }}
                icon={
                  isMobile ? (
                    <div className={ownClasses.tabIcon}>Content AI for Websites</div>
                  ) : (
                    <div className={ownClasses.tabIcon}>
                      <img
                        className={ownClasses.blackCheck}
                        src="https://qwa-assets.s3.us-east-2.amazonaws.com/get-started-magic-pen-large.svg"
                        alt="onboarding-background"
                      />
                      <div style={{ textAlign: 'left' }}>
                        <h4 className={ownClasses.tabHeading}>Use Content AI for Website</h4>
                        <Typography className={ownClasses.secondaryText}>
                          For Content Marketers, SEOs, Copywriters, & Business Owners.{' '}
                        </Typography>
                      </div>
                    </div>
                  )
                }
              ></Tab>
              <Tab
                className={ownClasses.tab}
                classes={{ selected: ownClasses.tabSelected }}
                icon={
                  isMobile ? (
                    <div className={ownClasses.tabIcon}>Book Demo for AI SEO Suite</div>
                  ) : (
                    <div className={ownClasses.tabIcon}>
                      <img
                        className={ownClasses.blackCheck}
                        src="https://qwa-assets.s3.us-east-2.amazonaws.com/get-started-calendar.svg"
                        alt="onboarding-background"
                      />
                      <div style={{ textAlign: 'left' }}>
                        <h4 className={ownClasses.tabHeading}>Book Demo of AI SEO Suite</h4>
                        <Typography className={ownClasses.secondaryText}>
                          SEO Platform for Enterprises, Global Brands, & Startups.{' '}
                        </Typography>
                      </div>
                    </div>
                  )
                }
              ></Tab>
              <Tab
                className={ownClasses.tab}
                classes={{ selected: ownClasses.tabSelected }}
                icon={
                  isMobile ? (
                    <div className={ownClasses.tabIcon}>Quick AI Tools</div>
                  ) : (
                    <div className={ownClasses.tabIcon}>
                      <svg
                        className={ownClasses.toolsSvg}
                        xmlns="http://www.w3.org/2000/svg"
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M4.97493 1.097C5.35906 0.712873 5.88005 0.49707 6.4233 0.49707H24.9606C25.5034 0.497549 26.0248 0.713485 26.4085 1.09742L31.4162 6.10512C31.6069 6.29554 31.7581 6.52172 31.8612 6.77069C31.9643 7.01967 32.0173 7.28654 32.017 7.556V17.4999C32.017 18.104 31.5274 18.5937 30.9233 18.5937C30.3192 18.5937 29.8295 18.104 29.8295 17.4999V7.61205L29.8699 7.6524C29.8572 7.63957 29.8471 7.62437 29.8401 7.60765C29.8332 7.59099 29.8296 7.57315 29.8295 7.55514V7.61205L24.9021 2.68457H24.9606C24.9239 2.68454 24.8877 2.67003 24.8617 2.64422M24.8617 2.64422L24.9021 2.68457H6.5625V2.54537C6.5625 2.58229 6.54783 2.61769 6.52173 2.6438C6.49562 2.6699 6.46021 2.68457 6.4233 2.68457H6.5625V32.3153H6.4233C6.46021 32.3153 6.49562 32.3299 6.52173 32.356C6.54784 32.3821 6.5625 32.4175 6.5625 32.4545V32.3153H16.6051C17.2092 32.3153 17.6989 32.8049 17.6989 33.409C17.6989 34.0131 17.2092 34.5028 16.6051 34.5028H6.4233C5.88006 34.5028 5.35906 34.287 4.97493 33.9028C4.5908 33.5187 4.375 32.9977 4.375 32.4545V2.54537C4.375 2.00212 4.5908 1.48113 4.97493 1.097"
                          fill="#1D3557"
                        />
                        <path
                          d="M14.8155 20.9999L18.4613 18.9583L16.4197 22.6041L18.4613 26.2499L14.8155 24.2083L11.1697 26.2499L13.2113 22.6041L11.1697 18.9583L14.8155 20.9999Z"
                          fill="#1D3557"
                        />
                        <path
                          d="M23.0247 24.9564L20.8014 22.7331L22.7331 20.8014L24.9564 23.0247L23.0247 24.9564ZM22.0862 19.954L19.9541 22.0862C19.5987 22.4233 19.5987 23.0156 19.9541 23.3709L30.5875 34.0043C30.9428 34.3597 31.5351 34.3597 31.8722 34.0043L34.0044 31.8722C34.3597 31.535 34.3597 30.9428 34.0044 30.5874L23.371 19.954C23.0156 19.5987 22.4233 19.5987 22.0862 19.954Z"
                          fill="#1D3557"
                        />
                        <path
                          d="M13.344 11.2676L8.75002 11.9592L12.3056 8.969L11.614 4.375L14.6042 7.93056L19.1982 7.239L15.6426 10.2292L16.3342 14.8232L13.344 11.2676Z"
                          fill="#1D3557"
                        />
                        <path
                          d="M22.852 16.0502L18.9583 16.6364L21.9719 14.102L21.3857 10.2083L23.9201 13.2218L27.8139 12.6357L24.8003 15.1701L25.3864 19.0638L22.852 16.0502Z"
                          fill="#1D3557"
                        />
                      </svg>
                      <div style={{ textAlign: 'left' }}>
                        <h4 className={ownClasses.tabHeading}>Start with Quick AI Tools</h4>
                        <Typography className={ownClasses.secondaryText}>
                          Complete Projects Faster with Uninterrupted Access to 18 AI Tools{' '}
                        </Typography>
                      </div>
                    </div>
                  )
                }
              ></Tab>
            </Tabs>
          ) : null}
        </div>

        {value == 0 ? (
          <>
            {fullPageContentAiLoader ? (
              <>
                <div
                  className="quattr-spinner-logo"
                  style={{ display: 'flex', position: 'relative', height: '84vh', width: '100%' }}
                >
                  <QLoaderWithHeadingDescription
                    heading={`Please wait & do not refresh screen.`}
                    description={`We are creating your Content AI account & ensuring you enjoy all its perks.`}
                    classes={ownClasses}
                  />
                </div>
              </>
            ) : (
              <OnboardingStylesWrapper
                component={GetStarted}
                classes={classes}
                user={{}}
                setFullPageContentAiLoader={setFullPageContentAiLoader}
              />
            )}
          </>
        ) : value == 1 ? (
          <BookDemoWrapper
            component={bookMeeting}
            setShowCalendly={setShowCalendly}
            showCalendly={showCalendly}
            classes={classes}
            user={{}}
          />
        ) : (
          <div className={ownClasses.aiToolsMainWrapper}>
            <div className={ownClasses.loaderWrapper}>
              {fullScreenLoader && (
                <QuattrLogoSpinner
                  text={`Please wait & do not refresh screen.\n We are verifying your purchase & ensuring you have a seamless journey.`}
                  classes={ownClasses}
                />
              )}
              {showToolsVerifyForm ? (
                <ToolsOnboardingWrapper handleChangePlan={handleChangePlanClick} classes={classes} />
              ) : showPricingAndPlans ? (
                <PricingSection
                  planPurchaseLoading={planPurchaseLoading}
                  handlePlanSelection={handlePlanSelection}
                  classes={classes}
                />
              ) : null}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
// export const getServerSideProps = withPageAuthRequired();

export default GetStartedWrapped;
